<div [ngStyle]="divStyle">
    <ion-icon 
    [src]="src"
    [ngStyle]="style"
    [slot]="slot"
    />
</div>
